import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const Container = styled.div`
  background-color: #fff;
  height: 100%;
  position: relative;
`;

export const Content = styled.div`
  width: 100%;
  padding: 30px 30px 0px;
  margin: 0 auto;
  text-align: center;

  .loading-products {
    height: 300px;
    ${mixins.flexPosition({ align: 'center' })}
  }
`;

export const Title = styled.h2`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
  margin-bottom: 10px;
`;

export const Text = styled.p`
  ${mixins.fontStyle(styles.colors.GRAY_MEDIUM, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
`;

export const Footer = styled.div`
  height: 80px;
  width: 100%;
  padding: 15px;
  ${mixins.flexPosition({ align: 'center' })}
  justify-content: ${({ center }) => (center ? 'center' : 'space-between')};
  background-color: #fff;
  box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.05);
`;



// WEBPACK FOOTER //
// ./src/components/SelectProductsModal/style.js